import { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'

import { CONTACT_ROUTE } from '@/utils/routes'

import { LinkCard } from '@/components/elements/LinkCard'
import { ImageTitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'

const renderContactTitle = (name: ReactNode): ReactNode => {
  if (
    typeof name === "string" &&
    name === "出店用地・建物、テナント出店"
  ) {
    return (
      <OpenStore>
        出店用地・建物、<span className="sp-break">テナント出店</span>
      </OpenStore>
    );
  }
  return <>{name}</>;
};

export const ContactPage = () => {
  return (
    <ContactMain>
      <ContactLinks>
        {CONTACT_ROUTE.subdirectories.map(
          ({ name, path, imagePath, ...other }) => (
            <LinkCard
              imgPath={imagePath}
              title={typeof name === "string" ? (renderContactTitle(name) as string) : ""}
              link={path}
              key={path}
              {...other}
            />
          )
        )}
      </ContactLinks>
    </ContactMain>
  )
}


ContactPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: 'お問い合わせ', path: '' },
  ]

  return (
    <>
      <Head
        title="お問い合わせ"
        description="トライアルホールディングスのお問い合わせはこちらから。"
        ogp={{ url: 'contact/' }}
      />
      <ImageTitleLayout
        title="Inquiry"
        subTitle="お問い合わせ"
        imgUrl="/images/top-contact.webp"
        breadCrumbs={breadCrumbs}
        isRequiredBackground={false}
      >
        {page}
      </ImageTitleLayout>
    </>
  )
}

const ContactMain = styled.div`
  width: 1040px;
  margin: 96px auto 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    margin: 40px auto 80px;
    padding: 0 20px;
  }
`
const ContactLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 45px;
  img {
    width: 150px;
    height: 120px;
    object-fit: contain;
    transform: translate(20px);
  }

  @media screen and (max-width: 1047px) {
    justify-content: center;
    gap: 38px;
    img {
      height: 140px;
      object-fit: contain;
    }
  }
`
const OpenStore = styled.span`
font-size: 15px; 

@media screen and (max-width: 1047px) { 
  .sp-break {
    display: block; 
  }
}
`;
